import 'marketing-ui/client'
import {
  initAccordion,
  initBreadcrumbs,
  initCombobox,
  initContentSlider,
  initDrawers,
  initFileInputs,
  initFooter,
  initForms,
  initHeader,
  initIconToggles,
  initImageSlider,
  initJumpLinks,
  initLabelToggles,
  initProductDetail,
  initProductSlider,
  initReadMore,
  initSearches,
  initUspSlider,
  initVideo,
  initYouTubeEmbeds,
  isSafari,
  polyfillPopoverPlacements,
} from 'marketing-ui/client'

function hydrate() {
  if (isSafari()) {
    polyfillPopoverPlacements()
  }

  initBreadcrumbs()
  initDrawers()
  initHeader()
  initIconToggles()
  initFooter()
  initProductDetail()
  initReadMore()
  initLabelToggles()
  initImageSlider()
  initProductSlider()
  initVideo()
  initForms()
  initContentSlider()
  initUspSlider()
  initSearches()
  initAccordion()
  initYouTubeEmbeds()
  initCombobox()
  initJumpLinks()
  initFileInputs()

  window.dispatchEvent(new CustomEvent('hydrated'))
}

hydrate()
